import type { RootState } from '~publish/legacy/store'

export const selectInstagramNotificationsComposerGuideScreen = (
  state: RootState,
): number => state?.guides?.instagramNotificationsComposerGuideStep
